import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../api/Authcontext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, userData, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  if (userData?.role !== 'admin') {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default AdminRoute;